import axios from "../api";
export const voteSbcSet = async (setId, voteType) => {
    await axios.post("/vote-sbc-set", { setId, voteType });
};
export const undoVoteSbcSet = async (setId, voteType) => {
    await axios.post("/undo-vote-sbc-set", { setId, voteType });
};
//# sourceMappingURL=voteSbcSet.js.map